/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { useState } from 'react';

import classnames from 'classnames';

import { color } from '@coursera/coursera-ui';
import { SvgChevronRight } from '@coursera/coursera-ui/svg';

import Markdown from 'bundles/cms/components/Markdown';
import TrackedButton from 'bundles/page/components/TrackedButton';

type Props = {
  question: string;
  answer: string;
  index: number;
};

const styles = {
  faq: css`
    border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    background-color: var(--cds-color-neutral-background-primary);
    margin-bottom: 20px;
  `,
  question: css`
    margin-top: 24px;
    font-size: 14px;
    background-color: transparent;
    border: none;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0;
    outline: none;
    text-align: left;
  `,
  answer: css`
    margin: 24px 60px 24px 55px;

    .visible {
      display: block;
    }
  `,
};

const Faq = ({ question, answer, index }: Props) => {
  const [expanded, setExpanded] = useState(false);

  const toggleFaq = () => {
    setExpanded(!expanded);
  };

  return (
    <li
      className={classnames('rc-Faq', { expanded })}
      css={styles.faq}
      aria-expanded={expanded}
      tabIndex={0}
      role="treeitem"
      aria-selected={expanded}
    >
      <TrackedButton
        className="faq-question"
        css={styles.question}
        onClick={toggleFaq}
        trackingName={'toggle_faq_' + index}
      >
        <SvgChevronRight
          size={20}
          style={{
            marginLeft: '24px',
            marginRight: '10px',
            transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
          }}
          color={color.primary}
        />
        <strong>{question}</strong>
      </TrackedButton>

      <div className="faq-answer" css={styles.answer}>
        <Markdown className={classnames('answer', { visible: expanded })} source={answer} />
      </div>
    </li>
  );
};

export default Faq;
